<template>
  <BLayout
    class="target mb-400"
    justify-space-between
    align-center
  >
    <span class="target-label">{{ label }}</span>
    <span class="fs-500 fw-bold">{{ count }}{{ $t('general.matter') }}</span>
  </BLayout>
</template>

<script setup lang="ts">
type TProps = {
  label: string;
  count: number;
};

defineProps<TProps>();
</script>

<style lang="scss" scoped>
  .target {
    background-color: $concrete-light;
    border-radius: $basespace-100;
    padding: $basespace-300 $basespace-400;
  }

  .target-label {
    color: $textcolor-light;
  }
</style>
